import React from 'react';

interface ICourseExtras {
  user_status: any
}

const CourseExtras: React.FC<ICourseExtras> = () => {
  return (
    <div className='bite-u-course-extras-cont'>
      {/* <h1>Instructors</h1>
      <Grid container spacing={6}>
        {instructors.map((inst, i) => (
          <Grid item key={i} sx={12} md={6}>
            <div className='bite-u-inst-cont' >
              <div className='bite-u-inst-img'></div>
              <div className='bite-u-inst-bottom'>
                <div className='bite-u-inst-words'>
                  <div className='bite-u-inst-head'>
                    <h2>{inst.name}</h2>
                    <h3>{inst.role}</h3>
                  </div>
                  <p>{inst.bio}</p>
                </div>
                <h4>Show more</h4>
              </div>
            </div>
          </Grid>
        ))}
      </Grid> */}
      {/* <h5 className='bite-u-cert-heading'>Certificate of Completion</h5>
      <p className='bite-u-cert'>Not completed</p> */}
    </div>
  );
};

export default CourseExtras;
